<template>
  <LoadingDialog v-model:visible="visible" :title="hasInvoice ? 'Преглед/преиздаване на фактура' : 'Издаване на фактура'" @init="onInit" @apply="onApply"
    :labelOk="hasInvoice ? 'Преиздай фактурата' : 'Издай нова фактура'" iconOk="pi-money-bill">
    <div v-if="hasInvoice">
      <iframe :src="pdf" style="width: 900px; height: 500px; border: 0;">
      </iframe>
    </div>
    <div v-else>
      За продажба <strong>{{data.sale && data.sale.number}}</strong> към клиент
      &quot;<strong>{{data.sale && data.sale.contragent.name}}</strong>&quot;
      няма издадена фактура.<br><br>
      Сигурни ли сте, че искате издаване на нова фактура за продажба?
    </div>
    <template #footer>
      <div v-if="data.documents && data.documents.length && data.documents.length > 0">
        <SelectButton v-model="tab" :options="tabs" optionLabel="name" optionValue="code" />
      </div>
    </template>
  </LoadingDialog>
</template>

<script>
export default {
  emits: {
    apply: null
  },
  data() {
    return {
        visible: false,
        sale: null,
        data: {},
        tabValue: false,
        pdf: null,
        tabs: [
          {name: "Оригинал", code: false},
          {name: "Копие", code: true},
        ]
    }
  },

  mounted() {
  },

  props: {
    title: {
      type: String,
      default: () => { return "Потвърждение за фактура" }
    },
    labelOk: {
      type: String,
      default: function() {
        return "Издай фактура";
      }
    },
    iconOk: {
      type: String,
      default: function() {
        return "pi pi-check";
      }
    },
  },
  methods: {
    onApply(callback) {
      this.data = {
        sale: this.sale,
        documents: false,
      }
      console.log(this.sale);
      this.$http.post('/invoice', null, {params: {sale: this.sale.id}})
        .then((res) => {
          this.data.documents = res.data
          callback(this.data)
          this.loadPdf()
        })
    },
    loadPdf() {
      if (this.hasInvoice) {
        this.$http.get('/content/invoice/' + this.data.documents[0].id, {params: {copy: this.tab}, responseType: 'blob'})
          .then((response) => {
            const blob = new Blob([response.data], { type: response.headers['content-type'] });
            const objectUrl = URL.createObjectURL(blob);
            this.pdf = objectUrl;
          })
      }
    },
    onInit(callback) {
      this.data = {
        sale: this.sale,
        documents: false,
      }
      this.$http.get('/invoice/sale', {params: {sale: this.sale.id}})
        .then((res) => {
          this.data.documents = res.data;
          callback(this.data);
          this.loadPdf()
        })
    },
    open(sale) {
      this.sale = sale
      this.visible = true
    }
  },
  computed: {
    tab: {
      get() {
        return this.tabValue
      },
      set(tab) {
        this.tabValue = tab
        this.loadPdf()
      }
    },
    hasInvoice: {
      get() {
        return this.data.documents && this.data.documents.length && this.data.documents.length > 0
      }
    }
  }
}
</script>

<style>
</style>
